import { render, staticRenderFns } from "./SnsPostCommentForm.vue?vue&type=template&id=6640d1ab&"
import script from "./SnsPostCommentForm.vue?vue&type=script&lang=js&"
export * from "./SnsPostCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports